import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeSpace' })
export class RemoveSpacePipe implements PipeTransform {
  transform(value: string, args: string[]): any {
    var myStr = value.replace(/(^\s+|[^a-zA-Z0-9 ]+|\s+$)/g, "");
    myStr = myStr.toLowerCase().replace(/\s+/g, "_");
    return myStr;
  }
} 



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/service/filter.pipe.ts